import { CryptoRepository } from 'common/repositories/index';

const _directiveDependencies = [];
const _controllerDependencies = ['$scope', 'Util'];

class CryptoMiningController {

    constructor($scope, Util) {

        $scope.isMining = false;
        $scope.currency = 'ETH';

        $scope.updateRigs = () => {

            $scope.rigs = CryptoRepository.getAllRigs() || [];

            let overallHashRate = 0;

            if ($scope.rigs.length > 0) {

                $scope.rigs.forEach((rig) => {

                    if (!rig.hashRate) {

                        rig.hashRate = 0;

                    }

                    overallHashRate += parseFloat(rig.hashRate);

                    rig.updatedHash = $scope.getHashRate(rig.hashRate);

                    if (rig.isMining) {

                        $scope.isMining = true;

                    }

                });

            }

            $scope.overallHashRate = $scope.getHashRate(overallHashRate);

        };

        $scope.updateRigs();

        const onCryptoDataNext = () => {

            $scope.updateRigs();

        };

        const onPayoutConfigNext = () => {

            const pendingBalances = CryptoRepository.getAll('pendingBalances') || {};
            const payoutConfig = CryptoRepository.getAll('payoutConfig') || {};

            if (Object.keys(pendingBalances).length > 0) {

                $scope.pendingBalance =
                    Util.toFixed(pendingBalances[$scope.currency], 6).toString();

            }

            if (Object.keys(payoutConfig).length > 0) {

                $scope.payoutConfig = payoutConfig[$scope.currency].minPayout;

            }

        };

        this.cryptoRepository = CryptoRepository.getObservableRigs();
        this.cryptoSubscriber = this.cryptoRepository
            .subscribe(
                data => onCryptoDataNext(data),
                () => { },
                () => { },
            );

        this.cryptoRepository = CryptoRepository.getObservable();
        this.cryptoSubscriber = this.cryptoRepository
            .subscribe(
                data => onPayoutConfigNext(data),
                () => { },
                () => { },
            );

    }

}


class CryptoMiningDirective {

    constructor() {

        this.template = require('./crypto-mining.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push(($scope, Util) =>
            new CryptoMiningController($scope, Util));
        this.controller = _controllerDependencies;
        this.controllerAs = 'CryptoMiningCtrl';

    }

}

_directiveDependencies.push(() => new CryptoMiningDirective());


angular.module('directives')
    .directive('cryptoMining', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/crypto-mining/crypto-mining.js